export const MOCK_DATA = [
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6614ZM038Y',
    id: 'oh:course:6614ZM038Y',
    name: {
      EN: 'Digital Business',
      NL: 'Digital Business',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_BA',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6013B0522Y',
    id: 'oh:course:6013B0522Y',
    name: {
      EN: 'Business Analytics',
      NL: 'Business Analytics',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EBA_BUSAD',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6314M0573Y',
    id: 'oh:course:6314M0573Y',
    name: {
      EN: 'Business Seminar 1',
      NL: 'Business Seminar 1',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_BAD',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6314M0574Y',
    id: 'oh:course:6314M0574Y',
    name: {
      EN: 'Business Seminar 2',
      NL: 'Business Seminar 2',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_BAD',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6614ZB008Y',
    id: 'oh:course:6614ZB008Y',
    name: {
      EN: 'New Business Models',
      NL: 'New Business Models',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_EPMS',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '5394QUIB3Y',
    id: 'oh:course:5394QUIB3Y',
    name: {
      EN: 'Quantum in Business',
      NL: 'Quantum in Business',
    },
    programmeType: 'DEGREE',
    programmeCode: 'NMA_QCS',
  },
  {
    __typename: 'EduPrepProgrammeSearchHit',
    code: 'EBA_ANALY',
    id: 'oh:programme:EBA_ANALY',
    name: {
      EN: 'B Business Analytics',
      NL: 'B Business Analytics',
    },
    programmeType: 'DEGREE',
  },
  {
    __typename: 'EduPrepProgrammeSearchHit',
    code: 'EMA_BE',
    id: 'oh:programme:EMA_BE',
    name: {
      EN: 'M Business Economics',
      NL: 'M Business Economics',
    },
    programmeType: 'DEGREE',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6314M0341Y',
    id: 'oh:course:6314M0341Y',
    name: {
      EN: 'Business Negotiations',
      NL: 'Business Negotiations',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_BAD',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6614ZB043Y',
    id: 'oh:course:6614ZB043Y',
    name: {
      EN: 'Business Negotiations',
      NL: 'Business Negotiations',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_EPMS',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6614ZM051Y',
    id: 'oh:course:6614ZM051Y',
    name: {
      EN: 'Business Negotiations',
      NL: 'Business Negotiations',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_BA',
  },
  {
    __typename: 'EduPrepCourseSearchHit',
    code: '6614ZM044Y',
    id: 'oh:course:6614ZM044Y',
    name: {
      EN: 'Scaling-up Businesses',
      NL: 'Scaling-up Businesses',
    },
    programmeType: 'DEGREE',
    programmeCode: 'EMA_BA',
  },
];
